module.exports = __webpack_public_path__ + "img/info.c3543df0.png";